
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Response } from '@angular/http';
import { Router, ActivatedRoute, Params, ParamMap } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { Subscription } from 'rxjs/Subscription';

import { ConsumidorService, ConsumidorModel } from './../shared/';

import { RecuperacaoSenhaService } from '../../../shared/service/recuperacao-senha.service';

import {
  MaskManager, NbpConfirmComponent, ParametrosService,
  ConfiguracoesProjeto,
  EqualValidator, CPFValidator, UtilHelper
} from '../../../shared';
import { StatusRequisicao } from '../../../shared/model/status-requisicao';
import { RecaptchaSafety } from '../../../shared/security/RecaptchaSafety';

@Component({
  selector: 'app-consumidor-alterar-senha',
  templateUrl: './consumidor-alterar-senha.component.html'
})
export class ConsumidorAlterarSenhaComponent implements OnInit, OnDestroy {

  public _consumidorAlterarSenhaForm: FormGroup;
  public _subscriptionConsumidorAlterarSenhaForm: Subscription;
  public _maskCPF = MaskManager.CPF;
  public _dadosConsumidorConfirmacao: ConsumidorModel;
  public _emailRecuperacaoEnviado = false;
  public _confirmarSenha = false;
  public _senhaAlterada = false;
  public _cpfLinkConfirmacao: string = null;
  public _guidLinkConfirmacao: string = null;
  public _msgSenhaAlteracao: string = null;
  public _msgExibirDados: string = null;
  public _erroSenhaAlterada = false;
  public _erroExibirDados = false;
  public exibeInfoSeguranca = false;
  public cpfCompleto = '';
  public recaptcha: string;

  public validRecaptcha = false;
  public config: ConfiguracoesProjeto;
  public _cpf: string;

  public msgErroRecuperacaoSenha: string;

  public useRecaptcha = true;

  public cpfBase: string;
  public cpfDigito: string;
  public guidEncoded: string;

  public _formErrors = {
    'cpf': [],
    'senha': [],
    'confirmarSenha': []
  };

  public _validationMessages = {
    'cpf': {
      'required': 'O Campo CPF é de preenchimento obrigatório.',
      'cpfInvalido': 'Informe um CPF válido.',
      'cpfNaoCadastrado': 'Não foi possível identificar sua conta.',
      'cpfViaGovBr': 'O seu acesso deve ser realizado através do botão "Entrar com gov.br".'
    },
    'senha': {
      'required': 'O Campo Nova Senha é de preenchimento obrigatório.',
      'minlength': UtilHelper.MsgGenericas.senha_minlength,
      'valorDiferente': UtilHelper.MsgGenericas.senha_naoConfirmada
    },
    'confirmarSenha': {
      'required': 'O Campo Confirmar Nova Senha é de preenchimento obrigatório.',
      'minlength': UtilHelper.MsgGenericas.senha_minlength,
      'valorDiferente': UtilHelper.MsgGenericas.senha_naoConfirmada
    }
  };

  public _msgErrosJSON = {
    senhaAlterada: 'Erro ao alterar a senha.',
    exibirDados: 'Erro ao exibir os dados.'
  };

  constructor(private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly consumidorService: ConsumidorService,
    private readonly recuperacaoSenhaService: RecuperacaoSenhaService,
    private readonly ngbModalService: NgbModal,
    private readonly parametrosService: ParametrosService) { }

  ngOnInit() {

    this.config = this.parametrosService.getConfiguracao();

    if(this.config.ambiente == RecaptchaSafety.AmbienteUsoObrigatorioRecaptcha) {
      this.useRecaptcha = true;
      this.recaptcha = this.config.recaptcha;
    }else{
      this.useRecaptcha = false;
      this.validRecaptcha = true;
    }

    this._cpfLinkConfirmacao = null;

    this._guidLinkConfirmacao = null;

    this._dadosConsumidorConfirmacao = null;

    this._emailRecuperacaoEnviado = false;

    this._confirmarSenha = false;

    this._senhaAlterada = false;

    this._msgSenhaAlteracao = null;

    this._msgExibirDados = null;

    this._erroSenhaAlterada = false;

    this._erroExibirDados = false;

    this._consumidorAlterarSenhaForm = new FormGroup({
      'cpf': new FormControl(null, [Validators.required, CPFValidator.validaCPF.bind(this)]),
      'senha': new FormControl(null, [Validators.required, Validators.minLength(6), EqualValidator.validaIgualdade.bind(this)]),
      'confirmarSenha': new FormControl(null, [Validators.required, Validators.minLength(6), EqualValidator.validaIgualdade.bind(this)])
    });

    this._subscriptionConsumidorAlterarSenhaForm = this._consumidorAlterarSenhaForm.valueChanges
      .subscribe(data => this.onValueChanged(data));

    this.activatedRoute.queryParamMap
      .subscribe((param: ParamMap) => {

        this.cpfBase = param.get("base");
        this.cpfDigito = param.get("digito");
        this.guidEncoded = param.get("guid");

        if (this.cpfBase && this.cpfDigito) {
          this._cpfLinkConfirmacao = this.concatenarCPF(parseInt(this.cpfBase), parseInt(this.cpfDigito));
          this._guidLinkConfirmacao = this.guidEncoded;
          this._confirmarSenha = true;
        }

      });

    if (this.consumidorService.editSenhaMode) {
      this._confirmarSenha = true;
      this._dadosConsumidorConfirmacao = this.consumidorService.getConsumidorModel();
    }
  }

  public get consumidorAlterarSenhaForm(): FormGroup {
    return this._consumidorAlterarSenhaForm;
  }

  public get maskCPF() {
    return this._maskCPF;
  }

  public get formErrors() {
    return this._formErrors;
  }

  public get validationMessages() {
    return this._validationMessages;
  }

  public get dadosConsumidorConfirmacao() {
    return this._dadosConsumidorConfirmacao;
  }

  public get emailRecuperacaoEnviado(): boolean {
    return this._emailRecuperacaoEnviado;
  }

  public get confirmarSenha(): boolean {
    return this._confirmarSenha;
  }

  public get senhaAlterada(): boolean {
    return this._senhaAlterada;
  }

  public get msgSenhaAlteracao(): string {
    return this._msgSenhaAlteracao;
  }

  public get erroSenhaAlterada(): boolean {
    return this._erroSenhaAlterada;
  }

  public get erroExibirDados(): boolean {
    return this._erroExibirDados;
  }

  public get msgExibirDados(): string {
    return this._msgExibirDados;
  }


  resolved(captchaResponse: string) {
    this.validRecaptcha = true;
  }

  public onProcurarCPF() {

    let cpf: string = this._consumidorAlterarSenhaForm.controls['cpf'].value || '';

    cpf = cpf.replace(/\.|\-|\_/g, '');

    const s: Subscription = this.consumidorService.getConsumidorPeloCPFParaRecuperacaoAcesso(parseInt(cpf))
      .subscribe((data: ConsumidorModel) => {
        s.unsubscribe();
        if (data.nome === null || data.nome === undefined || data.nome === '') {

            this.formErrors.cpf = [this.validationMessages.cpf.cpfNaoCadastrado];

        // Gov.br
        } else if (data.codOrigemCadastro == 2){

           this.formErrors.cpf = [this.validationMessages.cpf.cpfViaGovBr];

         } else {

          this._dadosConsumidorConfirmacao = data;
          this.cpfCompleto = `${UtilHelper.lpad(data.cpfBase.toString(), 9)}${UtilHelper.lpad(data.cpfDigito.toString(), 2)}`;

        }
        this.msgErroRecuperacaoSenha = '';

      }, error => {

        s.unsubscribe();

        let err = error as StatusRequisicao; 
        this.msgErroRecuperacaoSenha = err.motivo;

        this.cpfCompleto = '';
      });
  }

  public onGerarNovaSenha(): void {

    let cpfBase: string = this._dadosConsumidorConfirmacao.cpfBase.toString() || '';
    let cpfDigito: string = this._dadosConsumidorConfirmacao.cpfDigito.toString() || '';

    const pad = '000000000';
    const dig = '00';

    cpfBase = pad.substring(0, pad.length - cpfBase.length) + cpfBase;
    cpfDigito = dig.substring(0, dig.length - cpfDigito.length) + cpfDigito;

    const s: Subscription = this.recuperacaoSenhaService.getEmailLinkRecuperacaoSenha(cpfBase + cpfDigito)
      .subscribe((data: Response) => {
        s.unsubscribe();

        this._emailRecuperacaoEnviado = true;
        this._erroExibirDados = false;

      }, error => {

        s.unsubscribe();

        // Apresenta a mensagem de erro para o usuário.
        let erro = error as StatusRequisicao;

        this._msgExibirDados =  erro.motivo;
        this._emailRecuperacaoEnviado = false;
        this._erroExibirDados = true;
      });
  }

  public onNaoEhMinhaConta(): void {
    this.router.navigate(['/consumidor']);
  }

  public onAlterarSenha(): void {

    let cpf: string = this._cpfLinkConfirmacao;
    const guid: string = this.guidEncoded;
    const senha: string = this._consumidorAlterarSenhaForm.controls['senha'].value;

    if (!this.consumidorService.editSenhaMode) {
      this._cpf = cpf;
      const s: Subscription = this.recuperacaoSenhaService.postSalvarNovaSenha(cpf, guid, senha)
        .subscribe((data: Response) => {

          s.unsubscribe();

            this._senhaAlterada = true;
            this._erroSenhaAlterada = false;
            this.consumidorService.isSenhaAlterada = true;

        }, error => {

          s.unsubscribe();

           // Apresenta a mensagem de erro para o usuário.
          let erro = error as StatusRequisicao;
          this._msgSenhaAlteracao = erro.motivo;
        
          this._senhaAlterada = false;
          this._erroSenhaAlterada = true;  

        });
    } 
  }

  public onValueChanged(data?: any): void {

    for (const campo in this.formErrors) {
      const control = this.consumidorAlterarSenhaForm.get(campo);
      this.formErrors[campo] = [];

      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[campo];
        for (const key in control.errors) {
          if (messages[key]) {
            this.formErrors[campo].push(messages[key]);
          }
        }
      }
    }
  }

  public mascaraEmailConfidencial(email: string): string {
    const tamPrefixo: number = email.indexOf('@');
    const tamSufixo: number = email.indexOf('.', tamPrefixo);
    let e = '';

    if (tamSufixo > 0) {

      if(tamPrefixo == 1) {

        const dominio = this.ObterDominioEmail(email);
        const dominioMascarado = this.MascararDominioEmail(dominio);

        e = email[0] + "@" + dominioMascarado;

      }else if (tamPrefixo > 1) {

        e = email[0] +
        '*'.repeat(tamPrefixo - 2) + email.substring(tamPrefixo - 1, tamPrefixo + 2) +
        '*'.repeat(tamSufixo - tamPrefixo - 2) + email.substring(tamSufixo);
      }

    } else {

      e = email[0] +
        '*'.repeat(tamPrefixo - 2) + email.substring(tamPrefixo - 1, email.length);
    }

    return e;
  }

  private ObterDominioEmail(email :string){

    if(!email) 
      return null;

    return email.split('@').pop();
  }

  private MascararDominioEmail(dominio :string){

    if(!dominio) 
      return null;

      let dominioSeparado = dominio.split('.'); 
      let quantidadePalavrasDominio = dominioSeparado.length;

    if(quantidadePalavrasDominio == 0)
      return null;

      let primeiroCaracterePalavraInicialDominio = dominio[0];
      let quantidadeCaracteresPalavraInicialDominio = dominioSeparado[0].length;

      let palavraInicialDominioMascarado = primeiroCaracterePalavraInicialDominio + '*'.repeat(quantidadeCaracteresPalavraInicialDominio - 1);

      let num:number = 1;

    // Realiza a composição do restante do nome do domínio.
    for(num=1; num<quantidadePalavrasDominio; num++) {
      palavraInicialDominioMascarado = palavraInicialDominioMascarado + "." + dominioSeparado[num];      
    }

    return palavraInicialDominioMascarado;
  }

  private concatenarCPF(cpfBase: number, cpfDigito: number): string {

    const base: string = UtilHelper.lpad(cpfBase.toString(), 9);
    const digito: string = UtilHelper.lpad(cpfDigito.toString(), 2);

    return base + digito;
  }

  private cancelaAlterarSenha() {
    const confirmModal = this.ngbModalService.open(NbpConfirmComponent, { size: 'lg' });
    confirmModal.componentInstance.mensagem = 'Você tem certeza que deseja cancelar a recuperação da senha?';

    const unsubConfirm = confirmModal.componentInstance.userConfirmChange
      .subscribe(
        (userConfirm) => {
          if (userConfirm) {
            this.router.navigate(['inicio']);
            unsubConfirm.unsubscribe();
          }
        }
      );
  }

  ngOnDestroy() {
    this.consumidorService.editSenhaMode = false;
    this.exibeInfoSeguranca = false;
    this._subscriptionConsumidorAlterarSenhaForm.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-alterar-senha/consumidor-alterar-senha.component.ts